import cn from "classnames";
import { FormTemplate } from "components/modal/templates";
import { Datetime } from "components/shared/form";
import { formatDateTimezone } from "helpers/bidpoint";
import { dateToView, plainDate } from "helpers/date";
import { getInitialStateFromConfig } from "helpers/form";
import React from "react";
import { clearBidEstimatedLeaveDate, setBidEstimatedLeaveDate } from "sources/books/bids";

const config = {
    id: {},
    date: {
        label: "Расчетная дата выезда",
        inputProps: { name: "date" },
    },
    comment: {
        label: "Комментарий",
        inputProps: { name: "comment" },
        fieldWrapper: "col-sm-8 col-md-8",
        labelWrapper: "col-sm-4 col-md-4 col-form-label col-form-label-sm text-md-right text-sm-left",
    },
};

const initialState = getInitialStateFromConfig(config);

class SetBidEstimatedLeaveDate extends FormTemplate {
    sendRequest = (stateData) => {
        return setBidEstimatedLeaveDate(stateData).then(() => {
            this.props.refreshData(stateData);
            return true;
        });
    };

    clearDate = () => {
        this.setState({ isLoading: true });
        return clearBidEstimatedLeaveDate({ id: this.props.bid.id }).then(() => {
            this.props.refreshData();
            this.setState({ isLoading: false });
            this.close();
        });
    };

    setDateValue = ({ name, value }) => {
        this.setState({ [name]: plainDate(value) });
    };

    renderDateField = (props) => {
        const { date } = this.state;
        const bWrapper = cn("row mb-2");
        return (
            <Datetime
                inPortal
                bWrapper={bWrapper}
                wrapper="col-sm-8 col-md-4"
                labelWrapper="col-sm-4 col-md-4 col-form-label col-form-label-sm text-md-right text-sm-left"
                errorWrapper="col-sm-8 col-md-8 offset-sm-4 offset-md-4"
                label={props.label}
                inputProps={{
                    name: props.inputProps.name,
                    type: "datetime",
                }}
                libOptions={{
                    name: props.inputProps.name,
                    autoComplete: "off",
                }}
                onChange={this.setDateValue}
                value={date}
            />
        );
    };

    renderFormActions = () => {
        return (
            <div className="modal-window__footer modal-window__footer--between">
                {this.props.manualEstimatedLeaveDate ? (
                    <div className="btn btn-sm btn-danger" onClick={this.clearDate}>
                        Удалить
                    </div>
                ) : (
                    <div />
                )}
                <div>
                    {this.renderActionCancel()}
                    {this.renderActionSend()}
                </div>
            </div>
        );
    };

    renderBodyInner = () => {
        const { bidPoint } = this.props;
        return (
            <div className="mb-4">
                <div className="row form-group">
                    <label className="col-sm-4 col-md-4 col-form-label col-form-label-sm text-md-right text-sm-left">
                        Адрес
                    </label>
                    <div className="col-sm-8 col-md-8 col-form-label-sm">
                        {bidPoint.geozone.address}
                        &nbsp;
                        <span className="text-muted">{formatDateTimezone(bidPoint)}</span>
                    </div>
                </div>
                {this.renderDateField(config.date)}
                {this.renderField(config.comment)}
            </div>
        );
    };
}

const ConfiguredModal = (props) => {
    initialState.id = props.bid.id;
    initialState.date = props.manualEstimatedLeaveDate
        ? dateToView(props.manualEstimatedLeaveDate, "YYYY-MM-DD HH:mm:ss")
        : null;
    initialState.comment = props.comment;
    return <SetBidEstimatedLeaveDate {...props} config={config} initialState={initialState} />;
};

export default ConfiguredModal;
